module.exports = __webpack_public_path__ + "img/h5.0c1d0fff.png";